import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Preview from '../images/preview.png';
import Footer from '../components/footer/Footer';
import Header from '../components/header/Header';
import Modal from '../components/modal/Modal';
import QueryLoader from '../components/queryLoader/QueryLoader';
import SleepHealthReportBanner from '../components/sleepHealthReportBanner/SleepHealthReportBanner';

import getDefaultHomePageContent from '../hooks/staticQueries/useGetHomePageContent';

export default function Layout({ children, pageContext }) {
  const { pageName, headerItems, headerType } = pageContext;

  const [displaySleepHealthReportBanner] = useState(() => {
    if (typeof window === 'undefined') return false;
    return !window.location.pathname.startsWith('/booking');
  });

  const defaultHeaderItems = getDefaultHomePageContent().header_items;

  return (
    <>
      <Helmet>
        <link rel="icon" href="../../img/favicon.svg" />
        <title>Digital sleep clinic | Dreem Health</title>
        <meta property="og:title" content="Digital sleep clinic | Dreem Health" />
        <meta
          property="og:description"
          content="Care on your terms and schedule, with diagnosis & treatment options for your sleep condition. All from the comfort of your home."
        />
        <meta property="og:image" content={Preview} />
        <meta property="og:url" content="https://dreemhealth.com/" />
        <meta property="og:site_name" content="Digital sleep clinic | Dreem Health" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover"
        />
      </Helmet>
      <QueryLoader />
      <main className={pageName}>
        <Modal />

        {displaySleepHealthReportBanner && (
          <>
            <SleepHealthReportBanner />
            <div style={{ marginTop: '60px' }} />
          </>
        )}

        {headerType !== 'none' && (
          <Header
            items={headerItems || defaultHeaderItems}
            displaySleepHealthReportBanner={displaySleepHealthReportBanner}
            light={headerType === 'light'}
          />
        )}

        {children}

        {headerType === 'default' && <Footer />}
      </main>
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.element.isRequired,
  pageContext: PropTypes.shape({
    pageName: PropTypes.string.isRequired,
    headerType: PropTypes.string.isRequired,
    headerItems: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.string,
      type: PropTypes.string,
    })),
  }).isRequired,
};
